import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { addToCart, updateCart } from '../queries/cart-mutations.graphql';
import { setInitialCartId } from '../helpers/add-to-cart';
import { IUseAddToCart } from '../types/add-to-cart';

export const useAddToCart = ({ refetchCart, cookies, setCookie }: IUseAddToCart) => {
  const [isAddedToCart, setIsAddedToCart] = useState<boolean>(false);
  const [isUpdatedToCart, setisUpdatedToCart] = useState<boolean>(false);

  const [addProductQuery, { data: dataAddProduct, loading: loadingAddProduct, error: errorAddProduct }] = useMutation(
    addToCart,
    {
      onCompleted: setInitialCartId({ cookies, setCookie, refetchCart, setStateComplete: setIsAddedToCart }),
    }
  );

  const [
    updateProductQuery,
    { data: dataUpdateProduct, loading: loadingUpdateProduct, error: errorUpdateProduct },
  ] = useMutation(updateCart, {
    onCompleted: setInitialCartId({ cookies, setCookie, refetchCart, setStateComplete: setisUpdatedToCart }),
  });

  return {
    addProductQuery,
    updateProductQuery,
    dataAddProduct,
    loadingAddProduct,
    errorAddProduct,
    dataUpdateProduct,
    loadingUpdateProduct,
    errorUpdateProduct,
    isAddedToCart,
    isUpdatedToCart,
  };
};
